
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const AboutSection = () => {
  return (
    <section className="section-spacing bg-warm-white">
      <div className="container">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="font-heading text-deep-sage leading-tight mb-4 animate-fade-in">
              Wanderer zwischen den Welten
            </h2>
            <p className="text-soft-charcoal text-lg leading-relaxed animate-fade-in" style={{ animationDelay: '100ms' }}>
              Mein naturwissenschaftliches Studium lehrte mich, optimale Wachstumsbedingungen zu schaffen. 
              Diese systemische Denkweise wende ich heute auf Finanzen UND Führung an.
            </p>
          </div>

          <div className="p-6 bg-sage-50 rounded-2xl border border-sage-200/40 shadow-soft animate-fade-in" style={{ animationDelay: '200ms' }}>
            <p className="text-soft-charcoal mb-4 text-left font-medium">
              Besonders wirksam für Menschen, die merken:
            </p>
            <blockquote className="pl-4 border-l-3 border-primary/30 italic text-deep-sage/80 mb-5">
              „Die Standard-Playbooks passen nicht zu meinem Betriebssystem."
            </blockquote>
            <ul className="space-y-2">
              <li className="flex items-start gap-2">
                <ArrowRight className="h-4 w-4 text-primary flex-shrink-0 mt-1" />
                <span className="text-soft-charcoal text-sm">Scanner-Persönlichkeiten in Führungspositionen</span>
              </li>
              <li className="flex items-start gap-2">
                <ArrowRight className="h-4 w-4 text-primary flex-shrink-0 mt-1" />
                <span className="text-soft-charcoal text-sm">Hochsensible Entscheider</span>
              </li>
              <li className="flex items-start gap-2">
                <ArrowRight className="h-4 w-4 text-primary flex-shrink-0 mt-1" />
                <span className="text-soft-charcoal text-sm">Führungskräfte mit ausgeprägter Intuition</span>
              </li>
            </ul>
          </div>
          
          {/* Zeigarnik-Effekt: Unvollständige Info erzeugt Neugier */}
          <div className="mt-8 text-center animate-fade-in" style={{ animationDelay: '300ms' }}>
            <Link 
              to="/ueber-mich" 
              className="inline-flex items-center text-primary font-medium group hover:underline underline-offset-4 decoration-2"
            >
              Mehr über meinen Ansatz erfahren
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
